import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

function Campaign() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    PTCampaignID: null,
    PTDiscountID: "",
    Name: "",
    Description: "",
    CampaignCode: "",
    LinkToShare: "",
    InternalLink: "",
  });

  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/PTCampaign/PTCampaignGetCompleteDataSetForForeignKeys"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          setScreenListData(l_oResponse);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(AppContext.APIURL + "api/PTCampaign/PTCampaignGetCompleteGridData")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          // setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.PTDiscountID || addEditObject.PTDiscountID == 0) {
      showErrorMessage("Please select Discount");
      IsOkay = false;
    } else if (!addEditObject.Name || addEditObject.Name == "") {
      showErrorMessage("Please enter Name");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.PTCampaignID = addEditObject.PTCampaignID;
    object.PTDiscountID = addEditObject.PTDiscountID;
    object.PTDiscountName = addEditObject.PTDiscountName;
    object.Name = addEditObject.Name;
    object.Description = addEditObject.Description;
    object.CampaignCode = addEditObject.CampaignCode;
    object.LinkToShare = addEditObject.LinkToShare;
    object.InternalLink = addEditObject.InternalLink;

    // object.IsContractor = false;
    // object.CreatedByID = 0;
    // object.LastUpdatedByID = 0;
    // object.IsDeleted = false;
    axiosAuth
      .post(AppContext.APIURL + "api/PTCampaign/PTCampaignSave", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.PTCampaignID = pid;
    axiosAuth
      .post(AppContext.APIURL + "api/PTCampaign/PTCampaignDeleteRecord", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "PTDiscountName")) {
        (
          document.getElementById(
            "imgSort" + "PTDiscountName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Name")) {
        (
          document.getElementById("imgSort" + "Name") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Description")) {
        (
          document.getElementById("imgSort" + "Description") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      PTCampaignID: null,
                      PTDiscountName: "",
                      Name: "",
                      Description: "",
                      CampaignCode: "",
                      LinkToShare: "",
                      InternalLink: "",
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblcampaign", "campaign")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tblcampaign">
              <thead>
                <tr>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Discount
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "PTDiscountName")
                          }
                          data-function="ShowColumnFilterList"
                          title={"Search By Discount"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("PTDiscountName")}
                          title={"Sort By Discount"}
                        >
                          <span id={"imgSort" + "PTDiscountName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Name")}
                          data-function="ShowColumnFilterList"
                          title={"Search By Name"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Name")}
                          title={"Sort By Object Type"}
                        >
                          <span id={"imgSort" + "Name"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Description
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "Description")
                          }
                          data-function="ShowColumnFilterList"
                          title={"Search By Description"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Description")}
                          title={"Sort By Description"}
                        >
                          <span id={"imgSort" + "Description"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Campaign Code</th>
                  <th>Link To Share</th>
                  <th>Internal Link</th>
                  {/* <th>CreatedByName</th>
                <th>CreatedByUserName</th>
                <th>CreationTimestamp</th>
                <th>LastUpdatedByName</th>
                <th>LastUpdatedByUserName</th>
                <th>LastUpdatedTimestamp</th>
                <th>IsDeleted</th> */}
                  <th className="td-xxxs">Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.PTDiscountName}</td>
                          <td>{item.Name}</td>
                          <td>{item.Description}</td>
                          <td>{item.CampaignCode}</td>
                          <td>{item.LinkToShare}</td>
                          <td>{item.InternalLink}</td>
                          {/* <td>{item.CreatedByName}</td>
                        <td>{item.CreatedByUserName}</td>
                        <td>{formateDate(item.CreationTimestamp)}</td>
                        <td>{item.LastUpdatedByName}</td>
                        <td>{item.LastUpdatedByUserName}</td>
                        <td>{formateDate(item.LastUpdatedTimestamp)}</td>
                        <td>{item.IsDeleted == true ? "true" : "false"}</td> */}
                          <td className="td-xxxs">
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  setAddEditObject({
                                    PTCampaignID: item.PTCampaignID,
                                    PTDiscountID: item.PTDiscountID,
                                    Name: item.Name,
                                    Description: item.Description,
                                    CampaignCode: item.CampaignCode,
                                    LinkToShare: item.LinkToShare,
                                    InternalLink: item.InternalLink,
                                  });
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.PTCampaignID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Discount:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.PTDiscountID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PTDiscountID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Discount</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Name:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Description:
                </span>
                <textarea
                  className="input-field w-100"
                  // placeholder="Address"
                  rows={3}
                  value={addEditObject.Description}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Description: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Campaign Code:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.CampaignCode}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      CampaignCode: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Link To Share:
                </span>
                <textarea
                disabled={addEditObject.PTDiscountID == 21 ? false:true}
                  className="input-field w-100"
                  // placeholder="Address"
                  rows={3}
                  value={addEditObject.LinkToShare}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      LinkToShare: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Internal Link:
                </span>
                <textarea
                disabled={addEditObject.PTDiscountID == 21 ? true:false}
                  className="input-field w-100"
                  // placeholder="Address"
                  rows={3}
                  value={addEditObject.InternalLink}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      InternalLink: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Campaign;
